import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const NOCServices: React.FC = () => {
  const sections = [
    {
      title: '24/7 Network Operations Center (NOC) Services',
      content: 'Our NOC services provide continuous network monitoring, performance management, and infrastructure support. Our experienced network engineers monitor your IT infrastructure around the clock, ensuring optimal performance, availability, and quick resolution of network issues.',
      benefits: [
        '24/7/365 network monitoring and support',
        'Proactive issue detection and resolution',
        'Performance monitoring and optimization',
        'Infrastructure health and capacity management',
        'Detailed reporting and analytics'
      ]
    },
    {
      title: 'NOC Capabilities',
      content: 'Our NOC combines advanced monitoring tools with expert engineering support to ensure your network infrastructure operates at peak performance.',
      benefits: [
        'Multi-vendor network device support',
        'Automated alerting and escalation procedures',
        'Change management and configuration support',
        'Disaster recovery and business continuity support',
        'Integration with existing IT service management tools'
      ]
    }
  ];

  const sidebarInfo = [
    {
      title: 'Service Coverage',
      content: 'Comprehensive monitoring of routers, switches, firewalls, servers, applications, and cloud infrastructure.'
    },
    {
      title: 'Response Times',
      content: 'Guaranteed response times with escalation procedures for critical, high, medium, and low priority incidents.'
    },
    {
      title: 'Reporting',
      content: 'Regular performance reports, availability metrics, and capacity planning recommendations.'
    }
  ];

  return (
    <ServiceTemplate
      title="NOC Services"
      subtitle="Comprehensive 24/7 Network Operations Center services providing continuous infrastructure monitoring and support."
      sections={sections}
      ctaTitle="Optimize Your Network Performance"
      ctaDescription="Ensure maximum uptime and performance with our expert NOC services and proactive network management."
      sidebarInfo={sidebarInfo}
    />
  );
};

export default NOCServices;

